import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import type { ClientInterface } from "./types";

const ClientInterfaceContext = createContext<ClientInterface>("UNKNOWN");

interface ClientInterfaceProviderProps {
  clientInterface: ClientInterface;
  children: ReactNode;
}

export const ClientInterfaceProvider = ({
  clientInterface,
  children,
}: ClientInterfaceProviderProps) => (
  <ClientInterfaceContext.Provider value={clientInterface}>
    {children}
  </ClientInterfaceContext.Provider>
);

export const useIsNative = () => {
  const clientInterface = useContext(ClientInterfaceContext);
  return clientInterface.startsWith("NATIVE");
};

export const useClientInterface = () => {
  return useContext(ClientInterfaceContext);
};
